export const BOOKING_FUNCTION_NAME = "manage-booking-v2";
export const PAYMENT_FUNCTION_NAME = "manage-payment";
export const STORE_FUNCTION_NAME = "manage-store";
export const ARENA_FUNCTION_NAME = "manage-arena";
export const RETENTION_FUNCTION_NAME = "manage-retention";
export const GROWTH_OPS_FUNCTION_NAME = "manage-growth-ops";
export const VENUE_ANALYTICS_FUNCTION_NAME = "manage-venue-analytics";
export const ADMIN_FUNCTION_NAME = "manage-admin";
export const PRIVACY_FUNCTION_NAME = "manage-privacy";
